import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";
import {
  getOffsetFromParams,
  getLimitFromParams,
  makeParamsString
} from "./utils";
import _ from "lodash";
import { isLgLocationById } from "util/misc";

const isLgLocation = (resource, params) => {
  if (resource !== "comboLocations") return false;
  const id = _.get(params, "ids[0]", "");
  return isLgLocationById(id);
};

class ComboLocationsDataProvider extends BaseDataProvider {
  async getList(resource, params) {
    console.log(
      "ComboLocationsDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const offset = getOffsetFromParams(params);
    const limit = getLimitFromParams(params);
    const name = _.get(params, "filter.name", "");
    const paramsString = `
        name:"${name === "%%" ? "" : name}"
        offset:${offset}
        limit:${limit}
      `;

    const GET = gql`
      query {
        CombinedLocationsSearch(
          ${paramsString}
        ) {
          total
          offset
          limit
          sportsGraf {
            total
            data {
              id
              stableId
              name
              abbr
            }
          }
          localGraf {
            total
            data {
              stableId
              name
            }
          }
        }
      }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      const { localGraf, sportsGraf } = response.data.CombinedLocationsSearch;

      const lgData = localGraf.data.map((item) => {
        item.type = "localgraf";
        return item;
      });

      const sgData = sportsGraf.data.map((item) => {
        item.type = "sportsgraf";
        return item;
      });

      const data = [...sgData, ...lgData].reduce((acc, item, i, arr) => {
        const ids = acc.map((x) => x.stableId);
        if (item === null) return acc;

        // remove dupes (want to return sg item if it exists)
        if (item.stableId && ids.includes(item.stableId)) {
          return acc;
        }

        // save all the info we need in the id
        // so we can access it to create the sg location later
        if (item.type === "localgraf") {
          item.id = JSON.stringify(item);
        }

        return acc.concat(item);
      }, []);
      const r = {
        data: data,
        total: data.length
      };
      //console.log(JSON.stringify(r, null, 2));
      return r;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getOne(resource, params) {
    const GET = gql`
      query {
        data: LocationByID(id:"${params.id}") {
          id
          stableId
          name
          abbr
        }
      }`;
    try {
      const response = await this.client.query({ query: GET });
      return { data: response.data.data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getMany(resource, params) {
    // this is a hack to avoid getting an error on ReferenceInput components.
    if (isLgLocation(resource, params)) {
      return {
        data: [{ id: "123", name: "Placeholder" }]
      };
    }

    const promises = params.ids.map(async (id) => {
      const response = await this.getOne(resource, { id });
      return _.get(response, "data.data", response.data);
    });

    const response = await Promise.all(promises);
    return {
      data: response,
      total: response.length || 0
    };
  }

  async create(resource, params) {
    const CREATE_OBJECT = gql`
      mutation {
        UpsertLocation(${makeParamsString(params)}) {
          id
          name
          stableId
          abbr
        }
      }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.UpsertLocation };
  }
}

export default ComboLocationsDataProvider;
